import { Link, NavLink, useParams } from "react-router-dom";
import { MouseEventHandler, useState } from "react";
import { Button, Popover, Stack } from "@mui/material";
import { Portrait, Logout, HelpCenterOutlined, Menu, Home } from "@mui/icons-material";
import "./TopBar.css";
import AboutDialog from "src/components/pages/AboutDialog";

type TopBarProps = {
  loggedIn: boolean;
  logout: MouseEventHandler;
  connected?: boolean;
  reconnectAttempt?: number;
};

export default function TopBar({ loggedIn, logout, connected = true, reconnectAttempt = 0 }: TopBarProps) {
  const userName = localStorage.getItem("user-name");
  const userRole = localStorage.getItem("user-role");

  const [aboutDialogOpen, setAboutDialogOpen] = useState(false);

  const environment = localStorage.getItem("server-env") || "prod";
  const dbEnvironment = localStorage.getItem("db-env") || "";

  const commonButtonSx = {
    minWidth: "unset",
    padding: "3px 6px",
  };

  return (
    <div className={`top-bar ${environment === "dev" ? "dev" : ""}`}>
      <div className="title-environment-wrapper">
        <span className={`cgo-title ${environment === "dev" ? "dev" : ""}`}>
          <NavLink to="/">
            <span className="logo-c logo-letter">C</span>zech
            <span className="logo-g logo-letter">G</span>ames
            <span className="logo-o logo-letter">O</span>nline
          </NavLink>
        </span>
        <span className={`cgo-title-small ${environment === "dev" ? "dev" : ""}`}>
          <NavLink to="/">
            <span className="logo-c logo-letter">C</span>
            <span className="logo-g logo-letter">G</span>
            <span className="logo-o logo-letter">O</span>
          </NavLink>
        </span>
        {environment === "dev" && (
          <span className="environment-indicator">{(dbEnvironment !== "" ? dbEnvironment : "UNKNOWN") + " DB"}</span>
        )}
      </div>

      {!connected && (
        <div className="connection-status disconnected">
          <span className="connection-spinner"></span>
          <span className="connection-text">Reconnecting{reconnectAttempt > 0 ? ` (${reconnectAttempt})` : "..."}</span>
        </div>
      )}

      {loggedIn ? (
        <div className="top-bar-right">
          <div className="top-bar-user-display">
            <span className="user-name">{userName}</span>
            <span>({userRole})</span>
          </div>
          <div className="top-bar-buttons-wrapper">
            <Link to={"user/" + userName}>
              <Button variant="contained" size="small" sx={commonButtonSx}>
                <Portrait />
                <span className="full-button-text">Profile</span>
              </Button>
            </Link>
            <Button variant="contained" size="small" sx={commonButtonSx} onClick={() => setAboutDialogOpen(true)}>
              <HelpCenterOutlined />
              <span className="full-button-text">Help</span>
            </Button>
            <Button variant="contained" size="small" onClick={logout} sx={commonButtonSx}>
              <Logout />
              <span className="full-button-text">Log out</span>
            </Button>
          </div>
          <AboutDialog open={aboutDialogOpen} onClose={() => setAboutDialogOpen(false)} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export function TopBarAsButton() {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLButtonElement | null>(null);
  const menuOpen = Boolean(menuAnchorEl);
  const userName = localStorage.getItem("user-name");
  let params = useParams();
  const [aboutDialogOpen, setAboutDialogOpen] = useState(false);

  const commonButtonSx = {
    minWidth: "unset",
    padding: "3px 9px",
  };

  const menuButtonEl = (
    <Button onClick={(e) => setMenuAnchorEl(e.currentTarget)} variant="contained" size="small" sx={commonButtonSx}>
      <Menu />
    </Button>
  );

  return (
    <>
      <Popover
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        anchorEl={menuAnchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        slotProps={{ paper: { sx: { backgroundColor: "black" } } }}
      >
        <Stack direction="row" spacing={1} padding={1}>
          <Link to={"/"}>
            <Button variant="contained" size="small" sx={commonButtonSx}>
              <Home />
            </Button>
          </Link>
          <Link to={"/user/" + userName}>
            <Button variant="contained" size="small" sx={commonButtonSx}>
              <Portrait />
            </Button>
          </Link>
          <Button variant="contained" size="small" sx={commonButtonSx} onClick={() => setAboutDialogOpen(true)}>
            <HelpCenterOutlined />
          </Button>
          <Link to={"/projects/" + params.projectSlug}>
            <Button variant="contained" size="small" sx={commonButtonSx}>
              <Logout />
            </Button>
          </Link>
        </Stack>
      </Popover>
      {menuButtonEl}
      <AboutDialog open={aboutDialogOpen} onClose={() => setAboutDialogOpen(false)} />
    </>
  );
}
